import React from 'react'
import styles from './index.module.scss'

export const FullScreenOverlay = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={`${styles.overlay}`}>
      <div className={styles.overlayContent}>{children}</div>
    </div>
  )
}
